import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { winvestaGreenProp } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const WIN04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WIN-04",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-04/winvesta-green-prop_WIN-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2022 - PDF - 182 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WIN-04",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-04/winvesta-green-prop_WIN-04_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 125 KB",
    },
];

const WIN05DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WIN-05",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-05/winvesta-green-prop_WIN-05_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2022 - PDF - 181 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WIN-05",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-05/winvesta-green-prop_WIN-05_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 124 KB",
    },
];

const WIN06DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WIN-06",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-06/winvesta-green-prop_WIN-06_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 141 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WIN-06",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-06/winvesta-green-prop_WIN-06_Basisinformationsblatt.pdf`,
        description: "Stand 01/2023 - PDF - 129 KB",
    },
];

const WIN07DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WIN-07",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-07/winvesta-green-prop_WIN-07_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2023 - PDF - 225 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WIN-07",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-07/winvesta-green-prop_WIN-07_Basisinformationsblatt.pdf`,
        description: "Stand 09/2023 - PDF - 129 KB",
    },
];

const WIN08DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WIN-08",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-08/winvesta-green-prop_WIN-08_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2023 - PDF - 221 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WIN-08",
        path: `${DOCUMENT_HOST}/docs/general/winvesta/winvesta-green-prop/WIN-08/winvesta-green-prop_WIN-08_Basisinformationsblatt.pdf`,
        description: "Stand 10/2023 - PDF - 132 KB",
    },
];

const WinvestaGreenProp = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(winvestaGreenProp.title)}</title>
                <meta name="description" content="winvesta green prop GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/bc277Bg.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/winvesta-green-prop.png"} alt="" />
                        </div>
                        <p>
                            Unternehmensgegenstand der Gesellschaft ist die Verwaltung und Anlage eigenen Vermögens im eigenen
                            Namen und auf eigene Rechnung einschließlich des Erwerbs, der Verwertung, Nutzung, Verwaltung und
                            Veräußerung von Immobilien und der Finanzierung von Immobilienprojekten durch die Vergabe von mehreren
                            Nachrangdarlehen oder auch eines Darlehens ohne qualifizierten Rangrücktritts.
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>winvesta green prop GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die winvesta green prop GmbH & Co. KG eine langfristig ausgerichtete
                            Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WIN04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WIN05DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WIN06DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WIN07DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WIN08DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:support@winvesta.de">support@winvesta.de</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

WinvestaGreenProp.getInitialProps = async ({ res, req, isServer }) => {
    if (req?.tenant !== "winvesta") res.redirect("/404");
    return { isServer };
};

export default WinvestaGreenProp;
